var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "accordion"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "list-categories heading-3-bold"
  }, _vm._l(_vm.field.value.boxes, function (box) {
    return _c('div', {
      staticClass: "accordion-link",
      class: {
        'accordion-link-active': box.id === _vm.selectedBox.id
      },
      on: {
        "click": function ($event) {
          return _vm.selectBox(box);
        }
      }
    }, [_c('svg', {
      staticClass: "arrow-asset",
      attrs: {
        "width": "28",
        "height": "25",
        "viewBox": "0 0 28 25",
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M16.5 0.9375L27.5 11.4375C27.8125 11.75 28 12.125 28 12.5625C28 12.9375 27.8125 13.3125 27.5 13.625L16.5 24.125C15.9375 24.6875 14.9375 24.6875 14.375 24.0625C13.8125 23.5 13.8125 22.5 14.4375 21.9375L22.75 14.0625H1.5C0.625 14.0625 0 13.375 0 12.5625C0 11.6875 0.625 11.0625 1.5 11.0625H22.75L14.4375 3.125C13.8125 2.5625 13.8125 1.5625 14.375 1C14.9375 0.375 15.875 0.375 16.5 0.9375Z",
        "fill": "currentColor"
      }
    })]), _c('div', {
      staticClass: "accordion-title"
    }, [_vm._v(_vm._s(box.title))])]);
  }), 0), _c('div', {
    staticClass: "categories-info"
  }, [_vm._m(0), _c('div', {
    staticClass: "text-container"
  }, [_c('div', {
    staticClass: "paragraph-1-large"
  }, [_vm._v(_vm._s(_vm.selectedBox.text))]), _c('div', {
    staticClass: "lead-1"
  }, [_vm._v(_vm._s(_vm.selectedBox.text2))]), _c('seu-button', {
    attrs: {
      "label": _vm.selectedBox.buttonName,
      "button-icon-before": _vm.arrow
    }
  })], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "asset-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/4.jpg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }